// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__24Oga","NavLink":"NavigationItems_NavLink__-te5o"};